<template>
  <div class="relative w-full h-[400px]">
    <img
      class="w-full h-full object-cover rounded-lg"
      src="https://source.unsplash.com/1600x900/?house"
      alt="Hero"
    />
    <div
      class="absolute inset-0 flex flex-col items-center justify-center text-white bg-black/50 rounded-lg"
    >
      <h1 class="text-4xl font-bold">Encontrá tu próximo hogar</h1>
      <div class="mt-4 flex items-center bg-white p-2 rounded-full shadow-md">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Buenos Aires, CABA, La Plata"
          class="px-4 py-2 outline-none w-80 text-black"
        />
        <button class="btn btn-primary">Buscar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: ''
    }
  }
}
</script>
